<template>
  <div class="wholesale-customer-info">
    <b-row class="m-0">
      <!-- Tên khách hàng / Công ty -->
      <b-col md="4">
        <b-form-group>
          <label>Tên khách hàng / Công ty:<b class="text-danger">*</b></label>
          <Autosuggest
            :model="customerModel.customerName"
            :suggestions="filteredOptionsCustomer"
            :suggestionName="'fullName'"
            placeholder="Nhập tên khách hàng / công ty"
            :limit="10"
            @select="onSelectCustomer"
            @change="onSearchChangeByName"
          >
            <template #custom="{ suggestion }">
              <div class="d-flex flex-column">
                <span v-if="suggestion.item.fullName">{{ suggestion.item.fullName }}</span>
                <span class="text-primary small" v-if="suggestion.item.phoneNo">
                  {{ suggestion.item.phoneNo }}
                </span>
                <span class="text-muted small" v-if="suggestion.item.taxCode">
                  MST: {{ suggestion.item.taxCode }}
                </span>
                <span v-if="suggestion.item.message">{{ suggestion.item.message }}</span>
              </div>
            </template>
          </Autosuggest>
        </b-form-group>
      </b-col>

      <!-- SĐT -->
      <b-col md="2">
        <b-form-group>
          <label>Số điện thoại:</label>
          <b-form-input
            size="sm"
            v-model="customerModel.customerMobile"
            placeholder="SĐT khách hàng"
          />
        </b-form-group>
      </b-col>

      <!-- MST -->
      <b-col md="2">
        <b-form-group>
          <label>Mã số thuế:</label>
          <b-form-input
            size="sm"
            v-model="customerModel.customerTaxCode"
            placeholder="MST"
          />
        </b-form-group>
      </b-col>

      <!-- Địa chỉ -->
      <b-col md="4">
        <b-form-group>
          <label>Địa chỉ:</label>
          <b-form-input
            size="sm"
            v-model="customerModel.customerAddress"
            placeholder="Địa chỉ khách hàng"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'
import { cloneDeep } from 'lodash'
import { TIME_TRIGGER } from '@/utils/constants'
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
import decounce from 'debounce'

export default {
  name: 'WholesaleCustomerInfo',
  components: { Autosuggest },
  props: {
    billData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      customerModel: {
        customerId: null,
        customerName: '',
        customerMobile: '',
        customerAddress: '',
        customerCity: null,
        customerDistrict: null,
        customerWard: null,
        customerType: 1,
        customerTaxCode: '',
        customerLastName: '',
        customerAppellation: null,
        totalPoint: 0,
      },
      filteredOptionsCustomer: [],
      skipLoaded: false,
    }
  },
  mounted() {
    this.customerModel = cloneDeep(this.billData.customerModel)
    if (this.customerModel.customerId) {
      this.fetchCustomerDetail(this.customerModel.customerId, false)
    }
    this.$nextTick(() => {
      this.skipLoaded = true
    })
  },
  watch: {
    customerModel: {
      handler(value) {
        if (this.skipLoaded) {
          this.$emit('onUpdate', value)
        }
      },
      deep: true,
    },
  },
  methods: {
    debounceSearch: decounce(function () {
      this.searchCustomerByName()
    }, TIME_TRIGGER),

    onSearchChangeByName(text) {
      this.customerModel.customerName = text || ''
      this.filteredOptionsCustomer = []
      this.debounceSearch()
    },

    onSelectCustomer(option) {
      if (!option.item.id) {
        this.customerModel.customerName = option.item.fullName || ''
        return
      }
      this.customerModel.customerId = option.item.id
      this.customerModel.customerName = option.item.fullName || ''
      this.customerModel.customerMobile = option.item.phoneNo || ''
      this.fetchCustomerDetail(option.item.id, true)
    },

    searchCustomerByName() {
      const text = (this.customerModel.customerName || '').trim()
      if (!text) return
      ApiService.get(`v1/customers?customerName=${encodeURIComponent(text)}&customerStatus=1`).then((res) => {
        const items = res.data?.data?.items || []
        if (items.length > 0) {
          this.filteredOptionsCustomer = items
        } else {
          this.filteredOptionsCustomer = [{ message: 'Không tìm thấy khách hàng', fullName: text }]
        }
      })
    },

    fetchCustomerDetail(customerId, overwrite) {
      ApiService.get(`/v1/customers/${customerId}`).then((res) => {
        const info = res.data.data
        if (overwrite) {
          this.customerModel.customerName = info.fullName || this.customerModel.customerName
          this.customerModel.customerMobile = info.phoneNo || this.customerModel.customerMobile
          this.customerModel.customerAddress = info.address || ''
          this.customerModel.customerCity = info.city || null
          this.customerModel.customerDistrict = info.district || null
          this.customerModel.customerWard = info.ward || null
          this.customerModel.customerType = info.type || 1
          this.customerModel.customerLastName = info.lastName || ''
        }
        this.customerModel.customerTaxCode =
          info.taxCode || this.customerModel.customerTaxCode || ''
      })
    },
  },
}
</script>

<style scoped>
.wholesale-customer-info {
  margin-bottom: 12px;
}
</style>
